import { Column2, Container, Section } from "../Layout/layoutElement";
import { Servicesimage, Servicesimg, ServicesText } from "./HomeElements";
import MainButton from "../button/MainButton";
import { VerticalColumn } from "../image/imgElement";
import { PORTAL_BASE_URL } from "../../constants/defaultValues";

const Services = () => {
  return (
    <Section bg="" padding="100px 0px">
      <Container>
        <Column2>
          <ServicesText>
            <h2 className="">Built for Convenient Payments</h2>
            <p className="">
              Join over 1000+ Nigerian businesses enjoying seamless payment
              services with one click
            </p>
            <a href={`/register`} rel="noreferrer">
              <MainButton text="Register" main={false} />
            </a>
          </ServicesText>
        </Column2>
        <Column2>
          <Servicesimg>
            <VerticalColumn>
              <Servicesimage
                src="/img/pic7.png"
                alt={"pic"}
                height={"380px"}
                bottom={`0px`}
                left={`0px`}
                mwidth={"166px"}
                mheight={"207px"}
                mbottom={`0px`}
                mleft={`0%`}
              />
            </VerticalColumn>
            <VerticalColumn>
              <Servicesimage
                src="/img/pic8.png"
                alt={"pic"}
                height={"380px"}
                bottom={`30px`}
                left={`300px`}
                mwidth={"150px"}
                mheight={"201px"}
                mbottom={`30px`}
                mleft={`55%`}
                style={{top: "-2em"}}
              />
            </VerticalColumn>
          </Servicesimg>
        </Column2>
      </Container>
    </Section>
  );
};

export default Services;
